module.exports = __webpack_public_path__ + "static/media/shopping-cart-icon-black.dd45b6d2.svg";